<input
  [class]="{ invalid: control.invalid && control.touched }"
  type="text"
  [placeholder]="placeholder"
  [formControl]="control"
/>
